const url = require('url');

const REQUEST_POOL = [];
const POOL_SIZE = 1000;

class FullstxRequest {
    constructor() {
        this.raw = null;
        this.body = {};
        this.query = {};
        this.params = {};
        this.cookies = {};
        this.pathname = '';
        this.route = null;
    }

    init(rawReq) {
        this.raw = rawReq;
        this.body = {};
        this.query = {};
        this.params = {};
        this.cookies = {};
        this.route = null;

        const parsedUrl = url.parse(this.raw.url, true);

        this.query = parsedUrl.query;
        this.pathname = parsedUrl.pathname;

        const rc = this.raw.headers.cookie;
        if (rc) {
            rc.split(';').forEach((cookie) => {
                const parts = cookie.split('=');
                this.cookies[parts.shift().trim()] = decodeURI(parts.join('='));
            });
        }
    }

    get url() {
        return this.raw.url;
    }
    get method() {
        return this.raw.method;
    }
    get headers() {
        return this.raw.headers;
    }
    get socket() {
        return this.raw.socket;
    }

    on(event, listener) {
        this.raw.on(event, listener);
        return this;
    }
}

function getRequest(rawReq) {
    if (REQUEST_POOL.length > 0) {
        const req = REQUEST_POOL.pop();
        req.init(rawReq);
        return req;
    }
    const req = new FullstxRequest();
    req.init(rawReq);
    return req;
}

function releaseRequest(req) {
    req.raw = null;
    req.route = null;
    if (REQUEST_POOL.length < POOL_SIZE) {
        REQUEST_POOL.push(req);
    }
}

module.exports = {
    FullstxRequest,
    getRequest,
    releaseRequest
};
